<template>
   <div class="development-page">
      <div class="development-container">
         <div class="loop" v-for="(leg, index) in legs" :key="index">
            <CheckoutSSRs :data="checkoutSSRS[leg.index]" v-if="false" flight-identifier="193_12321313" />
            <CheckoutSSRsV2 :data="checkoutSSRS[leg.index]" v-if="true" flight-identifier="193_12321313" />
         </div>
      </div>
   </div>
</template>

<script>
// import dummy from "@/components/structural/flight/checkout/checkout_response.js";
import CheckoutSSRs from "@/components/structural/flight/checkout/CheckoutSSRs.vue";
import CheckoutSSRsV2 from "@/components/structural/flight/checkout/CheckoutSSRsV2.vue";
// import { formatCheckoutSsrs } from "@/helper/checkoutSsrs";
export default {
   name: "Development",
   components: {
      CheckoutSSRs,
      CheckoutSSRsV2,
   },
   data() {
      return {
         legs: {},

         checkoutSSRS: {},
      };
   },
   mounted() {
      //    console.clear();
      //    const legs = dummy.checkoutResponse.legs;
      //    const paxes = dummy.checkoutResponse.paxes;
      //    this.legs = legs;
      //    this.checkoutSSRS = formatCheckoutSsrs(legs, paxes);
   },
};
</script>

<style lang="scss" scoped>
.development-page {
   display: flex;
   justify-content: center;
   padding: 2rem 0;
}

.development-container {
   // width: 1300px;
   width: 90vw;
   background-color: #fff;
   padding: 1rem 2rem;
   min-height: 600px;
   border-radius: 1rem;
}
.loop {
   // border: 1px solid #ccc;
   margin: 3rem 1rem;
}
</style>
